import type React from 'react';

import styles from '@components/tags-component/styles/verktoyTagsComponent.module.scss';

import Tag from '@helsenorge/designsystem-react/components/Tag';

interface Props {
  tagTitle?: string;
  tagValue?: string;
  isPlainText?: boolean;
}

export const TagComponent = ({ tagTitle, tagValue, isPlainText }: Props): React.JSX.Element | null => {
  if (!tagValue) {
    return null;
  } else {
    if (isPlainText) {
      return (
        <>
          {tagTitle != null && <div className={styles.tagTitle}>{tagTitle}</div>}
          <div>{tagValue}</div>
        </>
      );
    } else {
      return (
        <>
          {tagTitle != null && <div className={styles.tagTitle}>{tagTitle}</div>}
          <Tag>{tagValue}</Tag>
        </>
      );
    }
  }
};

export default TagComponent;
